var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// TEAM_DELIVERABLES
var TEAM_DELIVERABLES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TeamDeliverables($id: ID!) {\n    team(id: $id) {\n      id\n      deliverables {\n        id\n        group_position\n      }\n    }\n  }\n"], ["\n  query TeamDeliverables($id: ID!) {\n    team(id: $id) {\n      id\n      deliverables {\n        id\n        group_position\n      }\n    }\n  }\n"])));
export var useTeamDeliverablesQuery = function (options) { return useQuery(TEAM_DELIVERABLES, options); };
export default TEAM_DELIVERABLES;
var templateObject_1;
